export class Organizacao {
    id: number;
    nome: string;
    descricao: string;
    cnpj: string;
    endereco: string;
    urlAcesso: string;
    otp: string;
    repositorio: String;
    chaveCA: string | any;
    senhaCA: string;
    usarHsm: boolean;
    usarSenha: boolean;
    usarOtp: boolean;
    excluido: boolean;
    regexPIN: string;
    fluxoEmissaoVarejo: boolean
}